"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var UI;
        (function (UI) {
            Globalize.addCultureInfo("en", {
                messages: {
                    Input_TreeItemMixedState: "{0} mixed"
                },
            });
            /** Tree node React class. */
            var TreeNode = /** @class */ (function (_super) {
                __extends(TreeNode, _super);
                function TreeNode(props) {
                    var _this = _super.call(this, props) || this;
                    /**
                     * Commits the Label edit changes.
                     * @param evt The blur event.
                     */
                    _this.commitChange = function (evt) {
                        _this.unbindHandlers(evt);
                        var newValue = _this.state.nodeName;
                        _this.name(newValue);
                        if (_this.props.node.Tree) {
                            _this.props.node.Tree.ApplyRename(true, newValue, _this.originalValue, _this.NodeId());
                            _this.originalValue = newValue;
                        }
                    };
                    /**
                     * Rollback the Label edit action and set the old value.
                     * @param evt The event.
                     */
                    _this.rollbackChange = function (evt) {
                        _this.setState({ nodeName: _this.originalValue });
                        _this.unbindHandlers(evt);
                        if (_this.props.node.Tree) {
                            _this.props.node.Tree.ApplyRename();
                        }
                    };
                    /**
                     * TreeItem click event handling function.
                     * @param event The click event.
                     */
                    _this.itemClick = function (event) {
                        if (_this.props.node.Tree) {
                            _this.props.node.Tree.ClickNode(_this, event);
                        }
                    };
                    /**
                     * Expand/Collapse button click event handling function.
                     * @param event The click event.
                     */
                    _this.buttonClick = function (event) {
                        if (_this.props.node.Tree && _this.HasChildren()) {
                            _this.props.node.Tree.ButtonClick(_this, event);
                            var nodeElement = _this.NodeElement();
                            if (nodeElement) {
                                nodeElement.focus();
                            }
                        }
                    };
                    /**
                     * Checkbox click event handling function
                     * @param event The click event.
                     */
                    _this.checkBoxClick = function (event) {
                        if (_this.props.node.Tree) {
                            _this.props.node.Tree.CheckBoxClick(_this, event);
                        }
                    };
                    /**
                     * Text change binding function.
                     * @param event The on change event.
                     */
                    _this.handleNameChange = function (event) {
                        _this.props.node.renderPending = true;
                        _this.setState({ nodeName: event.target.value });
                    };
                    _this.state = {
                        checkedState: _this.props.node.CheckedState,
                        hasChildren: _this.props.node.HasChildren,
                        isBold: _this.props.node.Bold,
                        isExpanded: _this.props.node.Expanded,
                        isReadOnly: true,
                        isSelected: _this.props.node.Selected,
                        nodeName: _this.props.node.name,
                    };
                    return _this;
                }
                /**
                 * Called by React Framework. This function determines if the React component should be rendered.
                 * @param nextProps Updated props.
                 * @param nextState Updated States.
                 * @returns True if the React element should render.
                 */
                TreeNode.prototype.shouldComponentUpdate = function (nextProps, nextState) {
                    return !!nextProps.node.renderPending;
                };
                /**
                 * Called by React Framework. This function is called everytime after the render is completed.
                 * @param nextProps Updated props.
                 * @param nextState Updated States.
                 */
                TreeNode.prototype.componentDidUpdate = function (nextProps, nextState) {
                    nextProps.node.renderPending = false;
                };
                /** Called by React Framework. This function is called before the components mount starts. */
                TreeNode.prototype.componentWillMount = function () {
                    // Populate the idMap array if the node data is not already present
                    // Also assign the react tree node object with node data
                    if (this.props.node.Tree) {
                        var nodeDataObj = this.props.node.Tree.NodeData(this.NodeId());
                        if (!nodeDataObj) {
                            nodeDataObj = this.props.node;
                            this.props.node.Tree.SetNodeData(this.NodeId(), nodeDataObj);
                        }
                        if (nodeDataObj) {
                            nodeDataObj.ReactNode = this;
                        }
                    }
                };
                /** Called by React Framework. This function is called when the components mount is complete. */
                TreeNode.prototype.componentDidMount = function () {
                    // Initial mount should take care of the expandCollapse button
                    this.fixExpandedAttribute(this.HasChildren(), this.Expanded());
                    // Add the TreeNode React object to the Selected nodelist of the tree
                    if (this.Selected() === true && this.props.node.Tree) {
                        this.props.node.Tree.AddSelection(this);
                    }
                };
                /**
                 * Render function for TreeNode, renders the tree node
                 * @returns The element to be rendered.
                 */
                TreeNode.prototype.render = function () {
                    var classObject = this.assignClass();
                    return (React.createElement("li", { className: classObject.nodeClasses, ref: "nodeElement", "aria-expanded": this.state.isExpanded, "data-expanded": this.state.isExpanded, "data-selected": this.state.isSelected, "aria-selected": this.CheckedState() === 1 ? "true" : "false", role: "treeitem", "data-dyn-id": this.NodeId(), "data-dyn-parentid": this.ParentId(), "data-dyn-index": this.props.node.index, "aria-setsize": this.props.node.siblingSize, "aria-posinset": this.GetPosition(), "aria-label": this._getAriaLabelForTreeNode(), tabIndex: this.state.isSelected ? 0 : -1, "aria-level": this.props.node.ariaLevel },
                        React.createElement("div", { className: "treeView-treeItem-header", onClick: this.itemClick },
                            React.createElement("button", { type: "button", className: "treeView-treeExpandCollapse", title: $dyn.label("Group_ExpandOrCollapse"), role: "button", onClick: this.buttonClick, tabIndex: -1, "aria-hidden": this.state.hasChildren ? null : true }),
                            React.createElement("button", { role: "presentation", type: "button", className: classObject.checkBoxClasses, onClick: this.checkBoxClick, tabIndex: -1, "data-checked": this.CheckedString() }),
                            this.state.isReadOnly ?
                                React.createElement("span", { className: classObject.labelClasses, ref: "inputItem", title: this.state.nodeName, tabIndex: -1 }, this.state.nodeName)
                                :
                                    React.createElement("input", { className: classObject.labelClasses, ref: "inputItem", onChange: this.handleNameChange, onBlur: this.commitChange, value: this.state.nodeName, size: 25, tabIndex: -1 })),
                        (this.props.node && this.props.node.Nodes && this.props.node.Nodes.length > 0) ? React.createElement($dyn.DynReact.UI._TreeNodeContainer, { Nodes: this.props.node.Nodes }) : null));
                };
                /**
                 * Return the current node id.
                 * @returns Current tree node id.
                 */
                TreeNode.prototype.NodeId = function () {
                    return this.props.node.Id;
                };
                /**
                 * Expanded property setter/getter function
                 * @param expanded Value of Expanded property to be set
                 * @returns True if the tree node is expanded
                 */
                TreeNode.prototype.Expanded = function (expanded) {
                    if (expanded !== undefined && this.props.node.Expanded !== expanded) {
                        this.props.node.Expanded = expanded;
                        this.props.node.renderPending = true;
                        // If the node is dirty and expanded
                        if (expanded && this.props.node.isDirty) {
                            this.props.node.Nodes = this.props.node.AllNodes;
                            this.props.node.Nodes.forEach(function (child) {
                                child.renderPending = true;
                            });
                            this.props.node.isDirty = false;
                        }
                        this.fixExpandedAttribute(this.HasChildren(), expanded); // This should call render
                    }
                    return this.props.node.Expanded;
                };
                /**
                 * CheckedState property setter/getter function.
                 * @param checked Value of ChekcedState property to be set.
                 * @returns Checked state of the tree node.
                 */
                TreeNode.prototype.CheckedState = function (checked) {
                    if (checked !== undefined && this.props.node.CheckedState !== checked) {
                        this.props.node.renderPending = true;
                        this.props.node.CheckedState = checked;
                        this.setState({ checkedState: checked });
                    }
                    return this.props.node.CheckedState;
                };
                /**
                 * Return the current node data.
                 * @returns Current tree node data.
                 */
                TreeNode.prototype.NodeData = function () {
                    return this.props.node;
                };
                /**
                 * Selected property setter/getter function.
                 * @param selected Value of Selected property to be set.
                 * @param keepInArray Flag indicates if the node should be kept in the tree selection list.
                 * @returns True if the tree node is selected.
                 */
                TreeNode.prototype.Selected = function (selected, keepInArray) {
                    if (selected !== undefined && this.props.node.Selected !== selected) {
                        this.props.node.Selected = selected;
                        this.props.node.renderPending = true;
                        if (this.props.node.Tree) {
                            // if keepInArray is not true then add/remove this node from selected nodelist
                            if (!keepInArray) {
                                if (selected) {
                                    this.props.node.Tree.AddSelection(this);
                                }
                                else {
                                    this.props.node.Tree.RemoveSelection(this);
                                }
                            }
                            if (!this.props.node.Tree.Root || this.props.node.Tree.Root.ActiveControl() === this.props.node.Tree.Name) {
                                var nodeElement = this.NodeElement();
                                if (nodeElement) {
                                    nodeElement.focus();
                                }
                            }
                        }
                        this.setState({ isSelected: selected });
                    }
                    return this.props.node.Selected;
                };
                /**
                 * Get the InputElement
                 * @returns HTML Element for the tree label input control
                 */
                TreeNode.prototype.InputElement = function () {
                    return this.refs.inputItem;
                };
                /**
                 * Return the current parent id.
                 * @returns Current tree node parent id.
                 */
                TreeNode.prototype.ParentId = function () {
                    return this.props.node.ParentId;
                };
                /**
                 * HasChildren property setter/getter function.
                 * @param has Value of HasChildren property to be set.
                 * @returns True if the tree node has children.
                 */
                TreeNode.prototype.HasChildren = function (has) {
                    if (has !== undefined && this.props.node.HasChildren !== has) {
                        this.props.node.renderPending = true;
                        this.props.node.HasChildren = has;
                        this.fixExpandedAttribute(has, this.Expanded());
                        this.setState({ hasChildren: has });
                    }
                    return this.props.node.HasChildren;
                };
                /**
                 * Children Count.
                 * @returns Returns total number of children.
                 */
                TreeNode.prototype.ChildCount = function () {
                    return this.props.node.AllNodes.length;
                };
                /**
                 * Get a specific Child.
                 * @param index The index of the child that needs to be returned.
                 * @returns Returns the specific child.
                 */
                TreeNode.prototype.GetChild = function (index) {
                    var child;
                    if (index >= 0 && index < this.ChildCount()) {
                        child = this.props.node.AllNodes[index].ReactNode;
                    }
                    return child;
                };
                /**
                 * Returns all children.
                 * @returns All children as array.
                 */
                TreeNode.prototype.GetChildren = function () {
                    return this.props.node.AllNodes;
                };
                /** Initializing the Label edit operation. */
                TreeNode.prototype.startRename = function () {
                    this.Readonly(false);
                    var inputElement = this.InputElement();
                    this.originalValue = inputElement && inputElement.value ? inputElement.value.trim() : "";
                    inputElement.focus();
                };
                /**
                 * Gets the checked state as string.
                 * @returns The checked state description.
                 */
                TreeNode.prototype.CheckedString = function () {
                    var value = this.CheckedState();
                    if (value === 2) {
                        return "mixed";
                    }
                    else if (value === 1) {
                        return "true";
                    }
                    return "false";
                };
                /**
                 * Gets the aria label of tree node.
                 * @returns The aria label of tree node.
                 */
                TreeNode.prototype._getAriaLabelForTreeNode = function () {
                    var ariaLabel = this.state.nodeName;
                    var value = this.CheckedState();
                    if (value === 2) {
                        ariaLabel = $dyn.format($dyn.label("Input_TreeItemMixedState"), ariaLabel);
                    }
                    return ariaLabel;
                };
                /**
                 * The name property setter/getter function.
                 * @param _name Value of name property to be set.
                 * @returns Tree node label.
                 */
                TreeNode.prototype.name = function (_name) {
                    if (_name !== undefined && this.props.node.name !== _name) {
                        this.props.node.renderPending = true;
                        this.props.node.name = _name;
                        this.setState({ nodeName: _name });
                    }
                    return this.props.node.name;
                };
                /**
                 * Update expanded attribue based on the HasChildren value.
                 * @param hasChildren Value of HasChildren property.
                 * @param expanded Value of Expanded property.
                 */
                TreeNode.prototype.fixExpandedAttribute = function (hasChildren, expanded) {
                    // When the HasChildren value changes we must set the aria-expanded attribute
                    // to show/hide the collapse button.
                    this.NodeElement();
                    // tslint:disable-next-line: triple-equals
                    if (hasChildren && hasChildren != "false") {
                        this.setState({ isExpanded: expanded });
                    }
                    else {
                        this.setState({ isExpanded: undefined });
                    }
                };
                /**
                 * Bold property setter/getter function.
                 * @param bold Value of Bold property to be set.
                 * @returns True if the tree node is bold.
                 */
                TreeNode.prototype.Bold = function (bold) {
                    if (bold !== undefined && this.props.node.Bold !== bold) {
                        this.props.node.renderPending = true;
                        this.props.node.Bold = bold;
                        this.setState({ isBold: bold });
                    }
                    return this.props.node.Bold;
                };
                /**
                 * ImageName property setter/getter function.
                 * @param imageName Value of ImageName property to be set.
                 * @returns Tree node image name.
                 */
                TreeNode.prototype.ImageName = function (imageName) {
                    if (imageName !== undefined && this.props.node.ImageName !== imageName) {
                        this.props.node.ImageName = imageName;
                    }
                    return this.props.node.ImageName;
                };
                /**
                 * ImageType property setter/getter function.
                 * @param imageType Value of ImageType property to be set.
                 * @returns Tree node image type.
                 */
                TreeNode.prototype.ImageType = function (imageType) {
                    if (imageType !== undefined && this.props.node.ImageType !== imageType) {
                        this.props.node.ImageType = imageType;
                    }
                    return this.props.node.ImageType;
                };
                /**
                 * AltText property setter/getter function.
                 * @param altText Value of AltText property to be set.
                 * @returns Tree node tooltip text.
                 */
                TreeNode.prototype.AltText = function (altText) {
                    if (altText !== undefined && this.props.node.AltText !== altText) {
                        this.props.node.AltText = altText;
                    }
                    return this.props.node.AltText;
                };
                /**
                 * Readonly property setter/getter function.
                 * @param readonly Value of Readonly property to be set.
                 * @returns True if the tree node is readonly.
                 */
                TreeNode.prototype.Readonly = function (readonly) {
                    if (readonly !== undefined) {
                        this.props.node.renderPending = true;
                        if (readonly) {
                            this.setState({ isReadOnly: readonly });
                        }
                        else {
                            this.setState({ isReadOnly: undefined });
                        }
                    }
                    return this.state.isReadOnly;
                };
                /**
                 * Return the preceding sibling node id.
                 * @returns Current tree node preceding sibling id.
                 */
                TreeNode.prototype.InsertAfterId = function () {
                    return this.props.node.InsertAfterId;
                };
                /**
                 * Get the position of this node under its parent.
                 * @returns Returns the current node position
                 */
                TreeNode.prototype.GetPosition = function () {
                    return this.props.node.index + 1;
                };
                /**
                 * Get total number of nodes under parent
                 * @returns Returns total number of nodes under parent
                 */
                TreeNode.prototype.GetSiblingSize = function () {
                    return this.props.node.siblingSize;
                };
                /**
                 * Get the NodeElement.
                 * @returns HTML Element for the tree node.
                 */
                TreeNode.prototype.NodeElement = function () {
                    return this.refs.nodeElement;
                };
                /**
                 * Unbind temporary keyboard handler those are created for Label edit.
                 * @param evt The event.
                 */
                TreeNode.prototype.unbindHandlers = function (evt) {
                    var $inputElement = $(this.InputElement());
                    if ($inputElement.length) {
                        $inputElement.off("focusout", this.rollbackChange);
                    }
                    this.Readonly(true);
                    evt.preventDefault();
                    evt.stopPropagation();
                };
                /**
                 * Helper function for render, initialize the classes based on the properties and states of the node.
                 * @returns Returns classes to be added to the DOM.
                 */
                TreeNode.prototype.assignClass = function () {
                    return {
                        checkBoxClasses: [
                            "treeView-checkbox"
                        ].join(" "),
                        labelClasses: [
                            "treeView-treeItemLabel",
                            this.state.isBold ? "treeView-treeItemLabel-Bold" : null,
                        ].join(" "),
                        nodeClasses: [
                            "treeView-treeItem",
                            this.state.isSelected ? "selected" : null
                        ].join(" "),
                    };
                };
                return TreeNode;
            }(React.Component));
            UI.TreeNode = TreeNode;
        })(UI = DynReact.UI || (DynReact.UI = {}));
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=TreeNode.js.map
